import { ColumnDef } from '@tanstack/react-table';
import { RouterOutput } from 'src/trpc';
import { StatusDisplay } from '../../components/StatusDisplay';
import { TruckStatus } from '@libs/schemas';

export const TruckColumns: ColumnDef<
  RouterOutput['admin']['truck']['getAllTrucks']['trucks'][0]
>[] = [
  {
    accessorKey: 'friendlyId',
    header: 'Truck ID',
    cell: ({ cell }) => {
      return (
        <div className="w-fit">
          <span className="underline">{cell.getValue() as string}</span>
        </div>
      );
    },
  },
  {
    accessorKey: 'size',
    header: 'Size',
    accessorFn: (row) => {
      const size = row.size.replace(/-/g, ' ');
      return size.replace(/\b\w/g, (l) => l.toUpperCase());
    },
  },
  {
    accessorKey: 'addons',
    header: 'Add Ons',
    accessorFn: (row) => {
      if (!row.addOns) {
        return 'None';
      }
      if (typeof row.addOns === 'string') {
        return (row.addOns as string).replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
      }
      const addOns = row.addOns.map((item) =>
        item.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()),
      );
      return addOns.join(', ') || 'None';
    },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ cell }) => <StatusDisplay status={cell.getValue() as TruckStatus} />,
  },
];
